









import {
  defineComponent,
  ref,
  PropType
} from '@nuxtjs/composition-api';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import { useCart } from '@wemade-vsf/customer';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true
    }
  },
  components: {
    SfButton
  },
  setup(props) {
    const { addItem, canAddToCart } = useCart();
    const isLoading = ref(false);

    const addToCart = async () => {
      isLoading.value = true;
      await addItem({
        product: props.product,
        quantity: 1
      });
      isLoading.value = false;
    }

    return {
      isLoading,
      addToCart,
      canAddToCart
    }
  }
})
